import { render, staticRenderFns } from "./ProductTiers.vue?vue&type=template&id=1be9d92c&scoped=true&lang=pug&"
import script from "./ProductTiers.vue?vue&type=script&lang=js&"
export * from "./ProductTiers.vue?vue&type=script&lang=js&"
import style0 from "./ProductTiers.vue?vue&type=style&index=0&id=1be9d92c&scoped=true&lang=css&"
import style1 from "./ProductTiers.vue?vue&type=style&index=1&id=1be9d92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9d92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBanner,VBtn,VDivider,VForm,VImg,VLayout,VProgressCircular,VRow,VTextField})
